export default __webpack_public_path__ + "static/media/tomato.150a0c04.jpg";